import { type Gender, getAgeGroupLabel, getGenderLabel } from 'src/data/demographics';
import type { ID } from 'src/lib/collection';

import { GENERATION_GUIDANCE_TYPE, GENERATION_MODE_TYPE, type GenerationModeType } from './const';
import { getGenerationGuidanceTypeLabel } from './guidanceType';
import type {
  MappedGenerationMode,
  SuggestionAnnotation,
  SuggestionRequest,
  ToneOfVoice,
} from './types';

export const formatSuggestionAnnotationLabel = (annotation: SuggestionAnnotation): string => {
  const title = getGenerationGuidanceTypeLabel(annotation.type);
  const description = formatSuggestionAnnotationDescription(annotation);
  return `${title}: ${description}`;
};

export const formatSuggestionAnnotationDescription = (annotation: SuggestionAnnotation): string => {
  if (annotation.type === GENERATION_GUIDANCE_TYPE.ageRange) {
    if (annotation.maxAge) {
      return `${annotation.minAge} - ${getAgeGroupLabel(annotation.maxAge)}`;
    }
    return annotation.minAge ? `${annotation.minAge}+` : '';
  }
  if (annotation.type === GENERATION_GUIDANCE_TYPE.gender) {
    return annotation.content ? getGenderLabel(annotation.content as Gender) : '';
  }
  return annotation.content || '';
};

export const getGuidanceDataFromGenerationResult = (
  result: SuggestionRequest
): SuggestionAnnotation | undefined => {
  if (!result.suggestionAnnotationType) {
    return;
  }

  return {
    type: result.suggestionAnnotationType,
    minAge: result.suggestionAnnotationMinAge,
    maxAge: result.suggestionAnnotationMaxAge,
    content: result.suggestionAnnotationContent,
  };
};

export const formatModeListId = (id: ID, type: GenerationModeType) => `${type}_${id}`;

export const getToneOfVoiceModes = (modes: ToneOfVoice[]): MappedGenerationMode[] =>
  modes.map((tov) => ({
    id: formatModeListId(tov.id, GENERATION_MODE_TYPE.toneOfVoice),
    realId: tov.id,
    type: GENERATION_MODE_TYPE.toneOfVoice,
    title: tov.title,
    hint: tov.hint,
  }));
